import { createContext, useContext, useState, useCallback } from "react";
import { AnimatePresence, motion } from "framer-motion";
import CatMascot from "../components/CatMascot";

const LoadingContext = createContext(null);

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
  const [state, setState] = useState({ show: false, label: "" });

  const withLoading = useCallback(async (promise, label = "Working...") => {
    setState({ show: true, label });
    try {
      return await promise;
    } finally {
      setTimeout(() => setState({ show: false, label: "" }), 350);
    }
  }, []);

  return (
    <LoadingContext.Provider value={{ withLoading }}>
      {children}
      <AnimatePresence>
        {state.show && (
          <motion.div
            data-testid="action-loading-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#070810]/85 backdrop-blur-md"
          >
            <motion.div
              animate={{ scale: [1, 1.12, 1], rotate: [0, -6, 6, 0] }}
              transition={{ repeat: Infinity, duration: 1.4, ease: "easeInOut" }}
              className="relative"
            >
              <div className="absolute inset-0 rounded-full blur-2xl bg-purple-600/40" />
              <CatMascot size={92} />
            </motion.div>
            <div className="mt-6 flex items-center gap-2">
              {[0, 1, 2].map((i) => (
                <motion.span
                  key={i}
                  className="h-2 w-2 rounded-full bg-purple-500"
                  animate={{ opacity: [0.2, 1, 0.2] }}
                  transition={{ repeat: Infinity, duration: 1, delay: i * 0.2 }}
                />
              ))}
            </div>
            <p className="mt-4 font-display text-sm font-semibold uppercase tracking-widest text-purple-300">{state.label}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </LoadingContext.Provider>
  );
};
